import React, { useState } from 'react';
import { useReveal } from '../lib/useReveal';
const FAQS = [{
  q: '¿Sirve si nunca trabajé constelaciones o genealogía antes?',
  a: 'Sí. El Tomo 1 — El Despertar de la Hija Pródiga — está diseñado para empezar desde cero. No necesitás experiencia previa en trabajo sistémico ni genealógico.'
}, {
  q: '¿Cómo recibo el material?',
  a: '100% digital en formato PDF. Después de tu pago recibís un email con acceso inmediato. En menos de 5 minutos tenés todo en tu dispositivo.'
}, {
  q: '¿Es lo mismo que la terapia o las constelaciones familiares?',
  a: 'No. Es un método de trabajo personal guiado que podés hacer en tu casa, a tu ritmo, con protocolos paso a paso. Complementa cualquier proceso terapéutico que estés haciendo.'
}, {
  q: '¿Sirve si mi familia no quiere trabajar estos temas?',
  a: 'Sí. El trabajo es tuyo. No necesitás que nadie de tu familia participe ni entienda lo que estás haciendo. El cambio empieza en vos y se expande desde ahí.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días, devolución completa, sin preguntas. Escribís a nuestro email y listo. Sin burocracia.'
}];
export function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#2D1B1B] py-12 md:py-16 px-5 sm:px-6 border-t border-[#C9A96E]/10" data-id="element-115">
      <div className="container mx-auto max-w-3xl" data-id="element-116">
        <div ref={ref1} className={`reveal text-center mb-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-117">
          <h2 className="text-3xl md:text-5xl font-bold text-[#F5ECD7] mb-4" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-118">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </h2>
        </div>

        <div className="space-y-3" data-id="element-119">
          {FAQS.map((faq, idx) => <div key={idx} className="bg-[#1C1410] rounded-xl border border-[#C9A96E]/20 overflow-hidden transition-all duration-300 shadow-md" data-id="element-120">
              <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" data-id="element-121">
                <span className="font-bold text-[#F5ECD7] pr-4" data-id="element-122">{faq.q}</span>
                <span className={`text-[#C9A96E] text-xl transition-transform duration-300 ${openIdx === idx ? 'rotate-45' : ''}`} data-id="element-123">
                  +
                </span>
              </button>
              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIdx === idx ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-124">
                <p className="text-[#FAF3E8] text-sm leading-relaxed" data-id="element-125">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}